<div class="dialog-content change-examItem-dialog">
  <!--title 標題-->
  <h1 class="dialog-title">已為您調整檢查項目</h1>

  <div class="change-item">
    <!-- 補回醫療建議檢查項目 -->
    <ng-container *ngIf="data.addedItems && data.addedItems.length > 0">
      <h2 class="section-title">補回醫療建議檢查項目</h2>
      <div class="included-items">
        <div class="item-row added">
          @for (item of data.addedItems; track item) {
            <div class="item-content">
              <img src="assets/img/plus.png" width="12" height="12" alt="">
              <span class="item-name">{{ item }}</span>
            </div>
          }
        </div>
      </div>
    </ng-container>

    <!-- 以下項目已包含在進階檢查中 -->
    <ng-container *ngIf="data.removedItems && data.removedItems.length > 0">
      <h2 class="section-title">以下項目已包含在進階檢查中</h2>
      <div class="included-items">
        <div class="item-row removed">
          @for (item of data.removedItems; track item) {
            <div class="item-content">
              <!-- 被移除的檢項 -->
              <div class="item-name">
                <img src="assets/img/minus.png" alt="" width="12" height="12">
                {{ item.examName }}
              </div>
              <div class="item-description">
                <!-- 升級檢項 -->
                已包含在
                <span>{{ item.includedExamName }}</span>
              </div>
            </div>
          }
        </div>
      </div>
    </ng-container>
  </div>

  <button class="btn-fill-primary btn-size-l" (click)="data.action()">
    {{ data.buttonText }}
  </button>
</div>
